module.exports = __webpack_public_path__ + "img/tooltipImage.c750119b.svg";